import React from "react";

export const MoreHorizontal = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.51416 10.2451C7.48066 10.2451 8.26416 11.0286 8.26416 11.9951V12.0051C8.26416 12.9716 7.48066 13.7551 6.51416 13.7551C5.54767 13.7551 4.76416 12.9716 4.76416 12.0051V11.9951C4.76416 11.0286 5.54767 10.2451 6.51416 10.2451ZM18.5141 10.2451C19.4806 10.2451 20.2641 11.0286 20.2641 11.9951V12.0051C20.2641 12.9716 19.4806 13.7551 18.5141 13.7551C17.5476 13.7551 16.7641 12.9716 16.7641 12.0051V11.9951C16.7641 11.0286 17.5476 10.2451 18.5141 10.2451ZM14.2641 11.9951C14.2641 11.0286 13.4806 10.2451 12.5141 10.2451C11.5476 10.2451 10.7641 11.0286 10.7641 11.9951V12.0051C10.7641 12.9716 11.5476 13.7551 12.5141 13.7551C13.4806 13.7551 14.2641 12.9716 14.2641 12.0051V11.9951Z"
        fill="#667085"
      />
    </svg>
  );
};
